var _this2 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Base64 } from 'js-base64';
import { jumpUpdate, updatePassword } from '@data/user';
export default {
  name: 'updatePwd',
  data: function data() {
    var _this = this;

    var verifyEnterPwd = function verifyEnterPwd(rule, value, callback) {
      //            let pattern = /^(\w){6,30}$/;
      if (value === '') {
        callback(new Error('请输入密码！'));
      } else if (!_this.tools.passwordVerify(value)) {
        callback(new Error(_this.msg.WARNING_5));
      } else {
        callback();
      }
    };

    var verifyAgainEnterPwd = function verifyAgainEnterPwd(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码！'));
        _this.isReset = true;
      } else if (value !== _this.form.newPwd) {
        callback(new Error('两次输入密码不一致！'));
        _this.isReset = true;
      } else {
        callback();
        _this.isReset = false;
      }
    };

    return {
      noShowFlag: false,
      isReset: true,
      //重置密码模块，两次输入的密码一致，“确定”按钮可点击
      form: {
        newPwd: '',
        confirmPwd: ''
      },
      formRules: {
        newPwd: [{
          required: true,
          trigger: 'change',
          validator: verifyEnterPwd,
          min: 6,
          max: 30
        }],
        confirmPwd: [{
          required: true,
          trigger: 'change',
          validator: verifyAgainEnterPwd,
          min: 6,
          max: 30
        }]
      }
    };
  },
  watch: {
    'resetObj.newPwd': function resetObjNewPwd() {
      if (_this2.tools.passwordVerify(_this2.form.newPwd) && _this2.form.newPwd === _this2.form.confirmPwd && _this2.form.newPwd && _this2.form.confirmPwd) {
        _this2.isReset = false;
      } else {
        _this2.isReset = true;
      }
    },
    'resetObj.confirmPwd': function resetObjConfirmPwd() {
      if (_this2.tools.passwordVerify(_this2.form.newPwd) && _this2.form.newPwd === _this2.form.confirmPwd && _this2.form.newPwd && _this2.form.confirmPwd) {
        _this2.isReset = false;
      } else {
        _this2.isReset = true;
      }
    }
  },
  methods: {
    //        checkPassword(val) {
    //            let pattern = /^(\w){6,30}$/;
    //            return !!pattern.exec(val);
    //        },
    resetPWDFn: function resetPWDFn() {
      var self = this;
      this.$refs.pwdForm.validate(function (valid) {
        if (valid) {
          var params = {
            password: Base64.encode(self.form.newPwd)
          };
          updatePassword(params).then(function () {
            // 去往下一个页面
            self.$router.push({
              path: '/choose'
            });
          }).catch(function () {});
        }
      });
    },
    continueUpdate: function continueUpdate() {
      var _this3 = this;

      if (this.noShowFlag) {
        // 已经勾选不在提示，当前点击跳过修改
        jumpUpdate().then(function () {
          // 去往下一个页面
          _this3.$router.push({
            path: '/choose'
          });
        }).catch(function () {});
      } else {
        // 直接去往下一个页面，下次在弹框
        this.$router.push({
          path: '/choose'
        });
      }
    }
  }
};